import type { Step } from "react-joyride";

export const documentDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າລາຍລະອຽດເອກະສານ. ທ່ານສາມາດເບິ່ງຂໍ້ມູນເອກະສານ, ລາຍການ, ປະຫວັດການດຳເນີນງານ ແລະ ດາວໂຫຼດ / ພິມ PDF.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="document-detail-header"]',
    content:
      "ຊື່ເອກະສານ, ສະຖານະ ແລະ ປຸ່ມດາວໂຫຼດ / ພິມ. ໃບຮັບເງິນສາມາດອອກໄດ້ຕໍ່ແຕ່ລະງວດຊຳລະໃນຕາຕະລາງດ້ານລຸ່ມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="document-detail-info"]',
    content:
      "ລາຍລະອຽດເອກະສານ ແລະ ລາຍການສິນຄ້າ / ບໍລິການ. ຍອດລວມປະກອບມີສ່ວນຫຼຸດ ແລະ VAT.",
    placement: "top",
  },
  {
    target: '[data-tourid="document-detail-history"]',
    content:
      "ປະຫວັດການດຳເນີນງານ: ສ້າງຮ່າງ, ອອກເອກະສານ, ຕໍ່ເປັນໃບບິນ / ໃບຮັບເງິນ, ຊຳລະ ຫຼື ຍົກເລີກ.",
    placement: "top",
  },
];
